module.exports = __webpack_public_path__ + "img/banner-roulette.acb75595.webp";